module.exports = __webpack_public_path__ + "img/logo-modera-white.622efab4.svg";